const initialState = () => ({
  isOpened: false,
  type: null,
  data: {},
  loading: false,
  error: null
});

const ACTION_KEY = 'REPORT_AUDIT';

const reducer = (state = initialState(), reduxAction) => {
  switch (reduxAction.type) {
    case `${ACTION_KEY}_MODAL_OPEN`: {
      const { data, type } = reduxAction.payload;
      return {
        ...state,
        data,
        type,
        isOpened: true
      };
    }
    case `${ACTION_KEY}_MODAL_CLOSE`: {
      return initialState();
    }
    case `${ACTION_KEY}_MODAL_PENDING`: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case `${ACTION_KEY}_MODAL_REJECTED`: {
      return {
        ...state,
        loading: false,
        error: reduxAction.payload
      };
    }
    case `${ACTION_KEY}_MODAL_FULFILLED`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
